<template>
  <form method="POST" :action="route">
    <input type="hidden" name="_token" :value="token" />
    <div class="col-12 text-center mx-auto mb-4">
      <p class="welcome-3 colortextmyfo1">Définissez vos objectifs</p>
      <div
        class="row justify-content-center dashboardstyle"
        style="background-color: #242527"
      >
        <table class="text-center py-0 px-4" style="margin: auto; width: 100%">
          <thead class="" style="font-size: 14px; color: #3867d6; width: 100%">
            <tr style="width: 100%">
              <th
                class="pb-2"
                scope="col"
                style="width: 25%; vertical-align: middle"
              >
                <svg
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 16 16"
                  class="bi bi-cash-stack svgframe"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14 3H1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1h-1z" />
                  <path
                    fill-rule="evenodd"
                    d="M15 5H1v8h14V5zM1 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H1z"
                  />
                  <path
                    d="M13 5a2 2 0 0 0 2 2V5h-2zM3 5a2 2 0 0 1-2 2V5h2zm10 8a2 2 0 0 1 2-2v2h-2zM3 13a2 2 0 0 0-2-2v2h2zm7-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                  /></svg
                >Montant investi (€)
              </th>
              <th
                class="pb-2"
                scope="col"
                style="width: 25%; vertical-align: middle"
              >
                <svg
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 16 16"
                  class="bi bi-smartwatch svgframe"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14 5h.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H14V5z" />
                  <path
                    fill-rule="evenodd"
                    d="M8.5 4.5A.5.5 0 0 1 9 5v3.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1 0-1h2V5a.5.5 0 0 1 .5-.5z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm0 1A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7z"
                  />
                  <path
                    d="M4 2.05v-.383C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v.383a2.512 2.512 0 0 0-.5-.05h-7c-.171 0-.338.017-.5.05zm0 11.9c.162.033.329.05.5.05h7c.171 0 .338-.017.5-.05v.383c0 .92-.746 1.667-1.667 1.667H5.667C4.747 16 4 15.254 4 14.333v-.383z"
                  /></svg
                >Date de début
              </th>
              <th
                class="pb-2"
                scope="col"
                style="width: 25%; vertical-align: middle"
              >
                <svg
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 16 16"
                  class="bi bi-graph-up svgframe"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"
                  /></svg
                >Date de fin
              </th>
              <th
                class="pb-2"
                scope="col"
                style="width: 25%; vertical-align: middle"
              >
                <svg
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 16 16"
                  class="bi bi-graph-up svgframe"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"
                  /></svg
                >Capital protégé
              </th>
              <th
                class="pb-2"
                scope="col"
                style="width: 25%; vertical-align: middle"
              >
                <svg
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 16 16"
                  class="bi bi-graph-up svgframe"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"
                  /></svg
                >Dynamisme
              </th>
            </tr>
          </thead>
          <tbody
            class="paragraphe text-center align-content-center"
            style="font-size: 12px; width: 100%"
          >
            <tr class="">
              <td
                class="text-justify p-2"
                style="width: 25%; vertical-align: middle"
              >
                <input
                  type="number"
                  class="form-control-4"
                  style="
                    font-size: 11px;
                    width: 100%;
                    text-transform: capitalize;
                  "
                  step="1"
                  min="0"
                  name="amount"
                  v-model="amount"
                  @change="onDataChange"
                />
              </td>
              <td
                class="text-justify p-2"
                style="width: 25%; vertical-align: middle"
              >
                <input
                  type="date"
                  id="start_day"
                  name="start_day"
                  min="2006-01-01"
                  v-model="start_day"
                  max="2020-12-31"
                  @change="onDataChange"
                />
              </td>
              <td
                class="text-justify p-2"
                style="width: 25%; vertical-align: middle"
              >
                <input
                  type="date"
                  id="end_day"
                  name="end_day"
                  v-model="end_day"
                  min="2006-01-01"
                  max="2020-12-31"
                  @change="onDataChange"
                />
              </td>
              <td
                class="text-justify p-2"
                style="width: 25%; vertical-align: middle"
              >
                <input
                  type="number"
                  class="form-control-4"
                  style="
                    font-size: 11px;
                    width: 100%;
                    text-transform: capitalize;
                  "
                  step="1"
                  min="0"
                  max="100"
                  name="floor_rate"
                  v-model="floor_rate"
                  @change="onDataChange"
                />
              </td>
              <td
                class="text-justify p-2"
                style="width: 25%; vertical-align: middle"
              >
                <input
                  type="number"
                  class="form-control-4"
                  style="
                    font-size: 11px;
                    width: 100%;
                    text-transform: capitalize;
                  "
                  step="1"
                  min="1"
                  max="7"
                  v-model="parameter"
                  name="parameter"
                  @change="onDataChange"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-12 mx-auto justify-content-center">
      <div
        class="row justify-content-center dashboardstyle"
        style="background-color: #242527"
      >
        <canvas ref="chart"></canvas>
      </div>
    </div>
    <div class="col-12 mx-auto justify-content-center mt-4">
      <div
        class="row justify-content-center dashboardstyle"
        style="background-color: #242527"
      >
        <canvas ref="chart1"></canvas>
      </div>
    </div>
    <!-- <div class="col-8 mx-auto text-center pt-4">
                <p class="welcome-3 colortextmyfo1">Probabilité de perte sur les investissements</p>
                <div class="row justify-content-center dashboardstyle py-2">
                    <table class="table table-responsive text-center table-borderless" style="margin:auto;">
                        <thead class="paragraphe" style="font-size: 14px; flex: 0 0 auto; color: #3867D6;">
                            <tr style="display: table; table-layout: fixed; width:100%">
                                <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Probabilité</th>
                                <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);"></th>
                            </tr>
                        </thead>
                        <tbody class="paragraphe text-center align-content-center" style="font-size: 12px; max-height: 600px; overflow: scroll; flex: 1 1 auto; display: block; overflow-y: auto; overflow-x: hidden;">
                            <tr style="display: table; width:100%">
                                <td class="text-center" style="vertical-align: middle;" >
                                    {{loss_probability}} %
                                </td>
                                <td class="text-center" style="vertical-align: middle;" >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
    <div class="m-4 justify-content-center text-center">
      <button type="submit" class="btn-alt-2 m-2 triggerspinner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-clockwise mr-1"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
          />
          <path
            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
          />
        </svg>
        Mettre en place cette stratégie
      </button>
    </div>
  </form>
</template>

<script>
import { Chart } from "chart.js";
const mathjs = require("mathjs");
export default {
  props: [
    "cppi_profiles",
    "benchmark_calendar_returns",
    "formatted_vols",
    "sum_assets",
    "token",
    "route",
  ],

  data() {
    return {
      testGraph: null,
      testGraph1: null,
      amount: this.sum_assets,
      parameter: 1,
      profile: 0.01,
      floor_rate: 10,
      start_day: "2019-12-31",
      end_day: "2020-12-31",
      benchmark_returns: [],
      data_portfolio: [],
      data_benchmark: [],
    };
  },

  mounted() {
    var ctx = this.$refs.chart.getContext("2d");
    var gradient = ctx.createLinearGradient(0, 0, 0, 400);
    var labels = [];

    gradient.addColorStop(0, "rgba(56, 103, 214,0.3)");
    gradient.addColorStop(0.5, "rgba(56, 103, 214,0.1)");
    gradient.addColorStop(1, "rgba(56, 103, 214, 0)");

    this.benchmark_calendar_returns.forEach((benchmark_calendar_return) => {
      this.benchmark_returns.push(benchmark_calendar_return);
      labels.push(benchmark_calendar_return.date.substring(0, 4));
    });

    this.testGraph = new Chart(ctx, {
      type: "line",
      data: {
        datasets: [
          {
            label: "Portefeuille",
            data: [],
            fill: true,
            backgroundColor: "rgba(56, 103, 214, .5)",
            fontFamily: "Poppins",
          },
          {
            label: "Capital protégé",
            data: [],
            fill: true,
            backgroundColor: "rgb(167, 238, 100)",
            fontFamily: "Poppins",
          },
          /* {
            label: "Portefeuille non rebalancé",
            data: [],
            fill: true,
            backgroundColor: "rgb(167, 238, 100)",
            fontFamily: "Poppins",
          }, */
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          easing: "easeInOutQuad",
          duration: 2000,
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              font: {
                size: 16,
              },
              fontFamily: "Poppins",
              boxWidth: 15,
              padding: 30,
            },
          },
        },
        scales: {
          y: {
            ticks: {
              // For a category axis, the val is the index so the lookup via getLabelForValue is needed
              callback: function (value, index, values) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(" ");
                return value + " " + "€";
              },
            },
          },
        },
      },
    });

    var ctx1 = this.$refs.chart1.getContext("2d");
    var gradient = ctx1.createLinearGradient(0, 0, 0, 400);
    var labels = [];

    gradient.addColorStop(0, "rgba(56, 103, 214,0.3)");
    gradient.addColorStop(0.5, "rgba(56, 103, 214,0.1)");
    gradient.addColorStop(1, "rgba(56, 103, 214, 0)");

    this.benchmark_calendar_returns.forEach((benchmark_calendar_return) => {
      this.benchmark_returns.push(benchmark_calendar_return);
      labels.push(benchmark_calendar_return.date.substring(0, 4));
    });

    this.testGraph1 = new Chart(ctx1, {
      type: "line",
      data: {
        datasets: [
          {
            label: "CAC 40",
            data: [],
            fill: true,
            backgroundColor: "rgb(108, 13, 45)",
            fontFamily: "Poppins",
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          easing: "easeInOutQuad",
          duration: 2000,
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              font: {
                size: 16,
              },
              fontFamily: "Poppins",
              boxWidth: 15,
              padding: 30,
            },
          },
        },
        scales: {
          y: {
            ticks: {
              callback: function (value, index, values) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(" ");
                return value + " " + "€";
              },
            },
          },
          x: {
            ticks: {
              fontFamily: "Poppins",
              fontColor: "rgb(56, 103, 214)",
              fontSize: 10,
            },
            gridLines: {
              offsetGridLines: true,
              display: false,
            },
            stacked: false,
          },
        },
      },
    });
    this.onDataChange();
  },

  methods: {
    cdfNormal(x, mean, standardDeviation) {
      return (
        (1 - mathjs.erf((mean - x) / (Math.sqrt(2) * standardDeviation))) / 2
      );
    },

    getStandardDeviation(array) {
      const n = array.length;
      const mean = array.reduce((a, b) => a + b) / n;
      return Math.sqrt(
        array.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n
      );
    },

    erfcinv(p) {
      let j = 0;
      let x, err, t, pp;
      if (p >= 2) return -100;
      if (p <= 0) return 100;
      pp = p < 1 ? p : 2 - p;
      t = Math.sqrt(-2 * Math.log(pp / 2));
      x =
        -0.70711 *
        ((2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t);
      for (; j < 2; j++) {
        err = this.erfc(x) - pp;
        x += err / (1.12837916709551257 * Math.exp(-x * x) - x * err);
      }
      return p < 1 ? x : -x;
    },

    erfc(x) {
      return 1 - this.erf(x);
    },

    deltaDate(input, days, months, years) {
      return new Date(
        input.getFullYear() + years,
        input.getMonth() + months,
        Math.min(
          input.getDate() + days,
          new Date(
            input.getFullYear() + years,
            input.getMonth() + months + 1,
            0
          ).getDate()
        )
      );
    },
    addDays(input, days) {
      var date = new Date(input);
      date.setDate(date.getDate() + days);
      return date;
    },
    erf(x) {
      const cof = [
        -1.3026537197817094, 6.4196979235649026e-1, 1.9476473204185836e-2,
        -9.561514786808631e-3, -9.46595344482036e-4, 3.66839497852761e-4,
        4.2523324806907e-5, -2.0278578112534e-5, -1.624290004647e-6,
        1.30365583558e-6, 1.5626441722e-8, -8.5238095915e-8, 6.529054439e-9,
        5.059343495e-9, -9.91364156e-10, -2.27365122e-10, 9.6467911e-11,
        2.394038e-12, -6.886027e-12, 8.94487e-13, 3.13092e-13, -1.12708e-13,
        3.81e-16, 7.106e-15, -1.523e-15, -9.4e-17, 1.21e-16, -2.8e-17,
      ];
      let j = cof.length - 1;
      let isneg = false;
      let d = 0;
      let dd = 0;
      let t, ty, tmp, res;

      if (x < 0) {
        x = -x;
        isneg = true;
      }

      t = 2 / (2 + x);
      ty = 4 * t - 2;

      for (; j > 0; j--) {
        tmp = d;
        d = ty * d - dd + cof[j];
        dd = tmp;
      }

      res = t * Math.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
      return isneg ? res - 1 : 1 - res;
    },
    treatAsUTC(date) {
      var result = new Date(date);
      result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
      return result;
    },
    daysBetween(startDate, endDate) {
      var millisecondsPerDay = 24 * 60 * 60 * 1000;
      return (
        (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) /
        millisecondsPerDay
      );
    },

    norminv(p, mean, std) {
      return -1.41421356237309505 * std * this.erfcinv(2 * p) + mean;
    },
    onDataChange() {
      // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance
      let labels = [];

      let benchmark_value = 0;
      let portfolio_value = 0;
      let floor = 0;
      let floor_computed = 0;
      let floor_graph = 0;
      let cushion = 0;
      let exposure = 0;
      let exposure_non_rebalanced = 0;
      let reserve_non_rebalanced = 0;
      let reserve = 0;
      let data_portfolio = [];
      let data_portfolio_non_rebalanced = [];
      let data_benchmark = [];
      let data_floor = [];
      let risk_free = 0;
      let probability = 2;
      let exposure_benchmark = 0;
      let reserve_benchmark = 0;
      let bound_factor = 0.05;
      //let parameter = 0;

      benchmark_value = this.amount;
      portfolio_value = this.amount;
      var start_year = this.start_day.substring(0, 4);
      var start_month = this.start_day.substring(5, 7);
      var start_day = this.start_day.substring(8, 10);

      var end_year = this.end_day.substring(0, 4);
      var end_month = this.end_day.substring(5, 7);
      var end_day = this.end_day.substring(8, 10);

      var start_date = new Date(start_year, start_month - 1, start_day);
      var end_date = new Date(end_year, end_month - 1, end_day);

      this.start_day_formatted = start_date.toISOString().split("T")[0];
      labels[0] = this.start_day_formatted;
      floor_computed = this.amount * (1-this.floor_rate/100);
      floor = Math.max(floor_computed / portfolio_value, floor_computed);
      floor_graph = floor;
      cushion = portfolio_value - floor;

      exposure = Math.max(
        0,cushion * this.parameter)

      exposure_non_rebalanced = exposure
      reserve_non_rebalanced = reserve

      let previous_exposure_upper = exposure*(1+bound_factor)
      let previous_exposure_lower = exposure*(1-bound_factor)

      exposure_benchmark = exposure;
      reserve = portfolio_value - exposure;
      reserve_benchmark = reserve;
      data_portfolio[0] = portfolio_value;
      data_portfolio_non_rebalanced[0] = portfolio_value;
      data_benchmark[0] = portfolio_value;
      data_floor[0] = floor;

      probability =
        1 -
        this.cdfNormal(
          cushion / exposure,
          0,
          this.formatted_vols.find((x) => x.date == this.start_day_formatted)[
            "price"
          ]
        );
      let diff_days = this.daysBetween(start_date, end_date);
      let js_day = start_date;

      for (let day = 1; day < diff_days; day++)
      {
        this.prev_day_formatted = js_day.toISOString().split("T")[0];
        js_day = this.addDays(js_day, 1);
        this.js_day_formatted = js_day.toISOString().split("T")[0];
        this.bench_return =
          parseFloat(
            this.benchmark_returns.find((x) => x.date == this.js_day_formatted)[
              "total_return"
            ]
          ) /
            parseFloat(
              this.benchmark_returns.find(
                (x) => x.date == this.prev_day_formatted
              )["total_return"]
            ) -
          1;
        portfolio_value =
          exposure * (1 + this.bench_return) + reserve * (1 + risk_free);

        cushion = portfolio_value - floor;

        exposure = Math.max(
          0,
          Math.min(portfolio_value,cushion * this.parameter))
        if (((exposure * (1 + this.bench_return)) / previous_exposure_upper) > (1+bound_factor))
        {
          exposure = Math.max(
          0,
          Math.min(portfolio_value,cushion * this.parameter));
          previous_exposure_upper = exposure*(1+bound_factor)
        }
        else if (((exposure * (1 + this.bench_return)) / previous_exposure_lower) < (1-bound_factor))
        {
          exposure = Math.max(
          0,
           Math.min(portfolio_value,cushion * this.parameter));
          previous_exposure_lower = exposure*(1-bound_factor)
        }
        else
        {
          exposure = exposure * (1 + this.bench_return)
        }

        exposure_non_rebalanced = exposure_non_rebalanced * (1 + this.bench_return)

        reserve = portfolio_value - exposure;

        //floor_graph = floor_graph * (1 + parseFloat(this.profile / 365));
        floor_graph = floor_graph;

        //data_portfolio[this.js_day_formatted] = portfolio_value;
        data_portfolio[day] = portfolio_value;
        data_portfolio_non_rebalanced[day] = exposure_non_rebalanced + reserve;

        exposure_benchmark = exposure_benchmark * (1 + this.bench_return);
        reserve_benchmark = reserve_benchmark * (1 + risk_free);
        benchmark_value = exposure_benchmark + reserve_benchmark;
        data_benchmark[day] = benchmark_value;

        //data_floor[this.js_day_formatted] = floor_graph
        data_floor[day] = floor_graph;

        labels[day] = this.js_day_formatted;
      }

      this.testGraph.data.labels = labels;
      this.testGraph.data.datasets[0].data = data_portfolio;
      this.testGraph.data.datasets[1].data = data_floor;
      this.testGraph.update();
      console.log("this.testGraph1", this.testGraph1);
      this.testGraph1.data.labels = labels;
      this.testGraph1.data.datasets[0].data = data_benchmark;
      this.testGraph1.update();
    },
  },
};
</script>
